import React from 'react';

export const NotFound = () => {
  return <div className="flex">Not Found</div>;
};
